import { Badge } from "@/components/ui/badge";
import type { ConviteListado, Perfil, SolicitacaoListada, StatusUsuario } from "@/lib/types";

const STATUS_CONVITE: Record<ConviteListado["status"], { label: string; variant: Parameters<typeof Badge>[0]["variant"] }> = {
  pending: { label: "Pendente", variant: "warning" },
  accepted: { label: "Aceito", variant: "success" },
  expired: { label: "Expirado", variant: "secondary" },
  revoked: { label: "Revogado", variant: "destructive" },
};

const STATUS_SOLICITACAO: Record<SolicitacaoListada["status"], { label: string; variant: Parameters<typeof Badge>[0]["variant"] }> = {
  pending: { label: "Pendente", variant: "warning" },
  approved: { label: "Aprovada", variant: "success" },
  rejected: { label: "Recusada", variant: "destructive" },
};

const STATUS_USUARIO: Record<StatusUsuario, { label: string; variant: Parameters<typeof Badge>[0]["variant"] }> = {
  active: { label: "Ativo", variant: "success" },
  inactive: { label: "Inativo", variant: "secondary" },
};

const PERFIL: Record<Perfil, { label: string; variant: Parameters<typeof Badge>[0]["variant"] }> = {
  admin: { label: "Admin", variant: "default" },
  premium: { label: "Premium", variant: "info" },
  user: { label: "Usuário", variant: "outline" },
};

export function StatusConviteBadge({ status }: { status: ConviteListado["status"] }) {
  const cfg = STATUS_CONVITE[status];
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}

export function StatusSolicitacaoBadge({ status }: { status: SolicitacaoListada["status"] }) {
  const cfg = STATUS_SOLICITACAO[status];
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}

export function StatusUsuarioBadge({ status }: { status: StatusUsuario }) {
  const cfg = STATUS_USUARIO[status];
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}

export function PerfilBadge({ perfil }: { perfil: Perfil }) {
  const cfg = PERFIL[perfil];
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}
